import { get } from "lodash";
import local from "./local";
import development from "./development";
import production from "./production";

const env = get(
  {
    local,
    development,
    production,
  },
  process.env.REACT_APP_LAYAPP_ENV || "local"
);

export default env;
